import { Navigation } from "../../components/Navigation/navigation";
import { Header } from "../../components/Header/header";
import { Features } from "../../components/Features/features";
import { Asset } from "../../components/Asset/asset";
import { Tokenomics } from "../../components/Tokenomics/tokenomics";
import { Roadmap } from "../../components/Roadmap/roadmap";
import { FAQ } from "../../components/FAQ/faq";

export const Landing = ( props ) => {
    return (
        <>
        <Navigation />
        <Header />
        <Features />
        <Asset />
        <Tokenomics/>
        <Roadmap />
        <FAQ />
        </>
    )
}